<template>
    <div
        v-if="checkEmployeeDiscount()"
        class="employee-discount text-center mb-3"
    >
        <form :action="base_url + '/apply-employee-discount'" method="get">
            <div v-html="formInputs"></div>
            <input
                v-if="remove_discount == 1"
                type="hidden"
                name="remove_discount"
                value="1"
            />

            <div class="row justify-content-center">
                <div class="col-md-9">
                    <div class="ml-2 text-right">
                        {{ tra.employee_discount }} |
                        <small
                            >{{ tra.institute_currency }} ({{
                                institute_currency
                            }})</small
                        >
                        <input
                            :style="'border: 1px solid #e7e7e7; height: 30px !important; border-radius: 5px; padding-right:10px; width: 100%;'"
                            type="number"
                            :max="
                                employee_discount_type == 'percentage'
                                    ? 100
                                    : ''
                            "
                            v-model="employee_discount"
                            @input="emitDiscountData"
                            name="employee_dsicount"
                        />
                        <small>{{ tra.fixed_discount_value_note }}</small>
                    </div>
                </div>
            </div>
            <hr class="my-2" />
            <div class="ml-4 d-inline-flex align-items-center">
                <span class="d-inline-flex align-items-center mx-3">
                    {{ tra.percentage }}
                    <input
                        class="mr-2"
                        @change="change_employee_discount_type()"
                        v-model="employee_discount_type"
                        value="percentage"
                        type="radio"
                        name="employee_discount_type"
                        style="height: 15px; width: 15px"
                    />
                </span>
                <span class="d-inline-flex align-items-center">
                    {{ tra.fixed_value }}
                    <input
                        class="mr-2"
                        @change="change_employee_discount_type()"
                        v-model="employee_discount_type"
                        value="fixed"
                        type="radio"
                        name="employee_discount_type"
                        style="height: 15px; width: 15px"
                    />
                </span>
            </div>
            <div class="ml-4 d-inline-flex align-items-center">
                <button
                    class="ml-xl-4 btn rounded-10 bg-secondary-color text-white"
                    type="submit"
                >
                    {{ tra.apply_discount }}
                </button>
                <button
                    @click="remove_discount = 1"
                    class="ml-xl-4 btn rounded-10 bg-danger text-white"
                    type="submit"
                >
                    {{ tra.cancel_discount }}
                </button>
            </div>
        </form>
    </div>
</template>

<script>
export default {
    props: ['base_url', 'formInputs', 'institute_currency', 'tra'],
    data() {
        return {
            user_details: {},
            remove_discount: 0,
            employee_discount: '',
            employee_discount_type: '',
        };
    },
    methods: {
        checkEmployeeDiscount: function () {
            if (this.user_details && this.user_details.roles && this.user_details.permissions &&
                (this.user_details.roles.includes('admin') || this.user_details.permissions.includes('employee-discount-create'))) {
                return true;
            }
            else {
                return false;
            }
        },
        
        get_user_details: function () {
            axios.get(this.base_url + '/get-user-details')
                .then(response => {
                    this.user_details = response.data.user;
                });
        },
        
        change_employee_discount_type: function () {
            if (this.employee_discount_type == "percentage") {
                if (this.employee_discount > 100) {
                    this.employee_discount = 0;
                }
            }
            // Emit the updated data to parent
            this.emitDiscountData();
        },
        
        get_employee_discount: function () {
            axios.get(this.base_url + '/get-employee-discount')
                .then(response => {
                    if (response.data.discount_type) {
                        this.employee_discount = response.data.discount;
                        this.employee_discount_type = response.data.discount_type;
                        // Emit initial data to parent
                        this.emitDiscountData();
                    }
                });
        },
        
        // Method to emit discount data to parent component
        emitDiscountData: function() {
            this.$emit('discount-updated', {
                employee_discount: this.employee_discount,
                employee_discount_type: this.employee_discount_type
            });
        }
    },
    computed: {},
    mounted() {
        this.get_user_details();
        this.get_employee_discount();
    },
};
</script>